import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, SubscriptionLike } from 'rxjs';
import {
  OverallUsers,
  PlanogramOverallData,
  UserAnalyticsDataModal,
  UserQueryModal,
  SelectionMap,
  SelectionType,
} from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';

interface UserAnalyticsData {
  id: number;
  bottler: string;
  unit: string;
  channel: string;
  caser: string;
  status: string;
}

interface UserAnalyticsQNA {
  id: number;
  name: string;
  bottler: string;
  createdOn: string;
  question: string;
  answer: string;
  isResolved: string;
}

@Component({
  selector: 'app-admin-user-analytics',
  templateUrl: './admin-user-analytics.component.html',
  styleUrls: ['./admin-user-analytics.component.css'],
})
export class AdminUserAnalyticsComponent implements OnInit, AfterViewInit {
  user_analytics_data_list: UserAnalyticsData[] = [];
  admin_user_analytics_data_subscription: SubscriptionLike;
  admin_user_analytics_data_observable: Observable<UserAnalyticsDataModal> =
    this.planogramState.admin_user_analytics_data;
  admin_user_analytics_data: UserAnalyticsDataModal;
  loader: Observable<boolean> = this.planogramState.loader;
  is_show_loader = false;
  expandedUserIndex: number | null = null;
  bottlers: string[] = [];
  units: string[] = [];
  channels: string[] = [];
  casers: string[] = [];
  planogram_status: string[] = [];
  selectedBottlers: string[] = [];
  selectedUnits: string[] = [];
  selectedChannels: string[] = [];
  selectedCasers: string[] = [];
  selectedPlanogramStatus: string[] = [];
  allBottlersSelected: boolean = false;
  allUnitsSelected: boolean = false;
  allChannelsSelected: boolean = false;
  allCasersSelected: boolean = false;
  allPlanogramStatusSelected: boolean = false;
  displayedColumns: string[] = [
    'bottler',
    'unit',
    'channel',
    'caser',
    'status',
  ];
  reply: string = '';
  dataSource = new MatTableDataSource<UserAnalyticsData>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  usersData: UserAnalyticsQNA[] = [];
  planogram_data: PlanogramOverallData;
  user_active: OverallUsers;
  admin_user_queries_data_subscription: SubscriptionLike;
  admin_user_queries_data_observable: Observable<UserQueryModal[]> =
    this.planogramState.admin_user_queries_data;
  admin_user_queries_data: UserQueryModal[];
  user_query_data: UserQueryModal[];
  filterd_user_analytics_data_list: UserAnalyticsData[] = [];

  constructor(private planogramState: PlanogramStateService) {
    this.admin_user_analytics_data_observable =
      this.planogramState.admin_user_analytics_data;
    this.planogramState.getAdminUserAnalyticsData();
    this.admin_user_analytics_data_observable =
      this.planogramState.admin_user_analytics_data;
    this.planogramState.getAdminUserQueriesData();
  }

  ngOnInit(): void {
    this.admin_user_analytics_data_subscription =
      this.admin_user_analytics_data_observable.subscribe(
        (data: UserAnalyticsDataModal) => {
          if (data && data.planogram_progress) {
            this.admin_user_analytics_data = data;
            this.user_analytics_data_list = data.planogram_progress.map(
              (detail, index) => ({
                id: index + 1,
                bottler: detail.bottler,
                unit: detail.unit,
                channel: detail.channel,
                caser: detail.caser,
                status: detail.status,
              })
            );
            this.setDropDownValues();
            this.setInitialSelection();
            this.dataSource = new MatTableDataSource(
              this.user_analytics_data_list
            );
            this.dataSource.paginator = this.paginator;
            this.planogram_data = data.planograms;
            this.user_active = data.users;
          }
        },
        (error) => {
          console.error('Error fetching user analytics data:', error);
        }
      );

    this.admin_user_queries_data_subscription =
      this.admin_user_queries_data_observable.subscribe(
        (data: UserQueryModal[]) => {
          if (data && data) {
            this.admin_user_queries_data = data;
            this.user_query_data = data.map((detail) => ({
              query_id: detail.query_id,
              user_id: detail.user_id,
              bottler: detail.bottler,
              subject: detail.subject,
              description: detail.description,
              resolved: detail.resolved,
              updated_at: detail.updated_at,
              email: detail.email,
              username: detail.username,
            }));
          }
        }
      );
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  setDropDownValues() {
    this.user_analytics_data_list.forEach((v) => {
      if (!this.bottlers.includes(v.bottler)) {
        this.bottlers.push(v.bottler);
      }
      if (!this.units.includes(v.unit)) {
        this.units.push(v.unit);
      }
      if (!this.channels.includes(v.channel)) {
        this.channels.push(v.channel);
      }
      if (!this.casers.includes(v.caser)) {
        this.casers.push(v.caser);
      }
      if (!this.planogram_status.includes(v.status)) {
        this.planogram_status.push(v.status);
      }
    });
  }

  setInitialSelection() {
    this.selectedBottlers = this.bottlers;
    this.selectedUnits = this.units;
    this.selectedChannels = this.channels;
    this.selectedCasers = this.casers;
    this.selectedPlanogramStatus = this.planogram_status;
    this.allBottlersSelected = true;
    this.allChannelsSelected = true;
    this.allUnitsSelected = true;
    this.allCasersSelected = true;
    this.allBottlersSelected = true;
    this.allPlanogramStatusSelected = true;
  }

  toggleAllOption(type: string) {
    const selectionMap: Record<SelectionType, SelectionMap> = {
      bottler: {
        allSelected: 'allBottlersSelected',
        selected: 'selectedBottlers',
        items: 'bottlers',
      },
      unit: {
        allSelected: 'allUnitsSelected',
        selected: 'selectedUnits',
        items: 'units',
      },
      channel: {
        allSelected: 'allChannelsSelected',
        selected: 'selectedChannels',
        items: 'channels',
      },
      caser: {
        allSelected: 'allCasersSelected',
        selected: 'selectedCasers',
        items: 'casers',
      },
      'planogram status': {
        allSelected: 'allPlanogramStatusSelected',
        selected: 'selectedPlanogramStatus',
        items: 'planogram_status',
      },
    };

    const selection = selectionMap[type as SelectionType];
    if (selection) {
      (this as any)[selection.allSelected] = !(this as any)[selection.allSelected];
        (this as any)[selection.selected] = (this as any)[selection.allSelected]
            ? (this as any)[selection.items]
            : [];
    }

    this.filterDataBasedOnFilterSelection();
  }

  checkOptionsSelected() {
    this.allBottlersSelected = this.selectedBottlers == this.bottlers;
    this.allUnitsSelected = this.selectedUnits == this.units;
    this.allChannelsSelected = this.selectedChannels == this.channels;
    this.allCasersSelected = this.selectedCasers == this.casers;
    this.allPlanogramStatusSelected =
      this.selectedPlanogramStatus == this.planogram_status;
  }

  filterDataBasedOnFilterSelection() {
    this.checkOptionsSelected();
    let dataFiltered = this.user_analytics_data_list.filter(
      (row: any) =>
        (this.selectedBottlers.length == 0
          ? this.bottlers.includes(row.bottler)
          : this.selectedBottlers.includes(row.bottler)) &&
        (this.selectedUnits.length == 0
          ? this.units.includes(row.unit)
          : this.selectedUnits.includes(row.unit)) &&
        (this.selectedChannels.length == 0
          ? this.channels.includes(row.channel)
          : this.selectedChannels.includes(row.channel)) &&
        (this.selectedCasers.length == 0
          ? this.casers.includes(row.caser)
          : this.selectedCasers.includes(row.caser)) &&
        (this.selectedPlanogramStatus.length == 0
          ? this.planogram_status.includes(row.status)
          : this.selectedPlanogramStatus.includes(row.status))
    );
    this.filterd_user_analytics_data_list = dataFiltered;
    this.dataSource.data = dataFiltered;
  }

  toggleQNASection(index: number): void {
    this.expandedUserIndex = this.expandedUserIndex === index ? null : index;
  }

  sendReply(user: any) {
    return `mailto:${user.email}?subject=Reply to : ${encodeURIComponent(
      user.subject
    )}&body=${encodeURIComponent(this.reply)}`;
    // if (reply.trim()) {
    //   const payload = { userId, reply };
    // }
  }

  markResolve(query_id: number, user_id: number) {
    this.planogramState.markResolveUserQuery(query_id, user_id);
  }

  ngOnDestroy(): void {
    this.admin_user_queries_data_subscription.unsubscribe();
    this.admin_user_analytics_data_subscription.unsubscribe();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Creation pending':
        return 'status-red';
      case 'Created on old database':
        return 'status-blue';
      case 'Created on new database':
        return 'status-green';
      default:
        return 'status-red';
    }
  }
}
